module.exports = __webpack_public_path__ + "static/Product_3Screens-a22d155edda4e8965bca771c3099bdac.png";